import { useController, useFormContext } from 'react-hook-form'

import { Card, TextField } from '@shopify/polaris'

import { useAccount } from '../hooks/useAccount'
import { getTranslation } from '../util/getTranslation'

export function SettingsPaymentLabel() {
  const account = useAccount()
  const defaultLabel = getTranslation('settings.default_payment_label', { shopName: account.shopName })

  const { setValue } = useFormContext()
  const { field } = useController({
    name: 'paymentLabel',
    defaultValue: account.segmentConfig.paymentLabel || '',
  })

  return (
    <Card.Section>
      <TextField
        {...field}
        label={getTranslation('settings.payment_description')}
        autoComplete=""
        placeholder={defaultLabel}
        onChange={(value) => setValue(field.name, value)}
      />
    </Card.Section>
  )
}
